import { TWILIO_DEVICE_REGISTERING, TWILIO_DEVICE_REGISTERED } from '../constants/twilioDeviceStatuses';
export const isDeviceLoading = tokenStatus => tokenStatus === TWILIO_DEVICE_REGISTERING;
export const isDeviceReady = tokenStatus => tokenStatus === TWILIO_DEVICE_REGISTERED;